import { render, staticRenderFns } from "./TrackingInformation.vue?vue&type=template&id=977623c4&scoped=true"
import script from "./TrackingInformation.vue?vue&type=script&lang=js"
export * from "./TrackingInformation.vue?vue&type=script&lang=js"
import style0 from "./TrackingInformation.vue?vue&type=style&index=0&id=977623c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977623c4",
  null
  
)

export default component.exports